import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from "history";
import createProvider from "./containers/ProviderWithErrBoundary";
import appReducer from "./redux/modules/rootReducer";
import thunk from "redux-thunk";
import App from './components/App';

const AppProvider = createProvider(appReducer, thunk)
const history = createBrowserHistory();
class Root extends React.Component {

  render() {
    return (
      <AppProvider>
        <BrowserRouter history={history}>
          <App />
        </BrowserRouter>
      </AppProvider>
    )
  }
}

export default Root;
